export default [
    {
        path: '/futures/official-verify',
        component: () => import('@/pages/v2/search'),
    },
  ];
  


// WEBPACK FOOTER //
// ./src/router/v2/search/index.js